import React from 'react';
import { Audio, useCurrentFrame, useVideoConfig, interpolate, Sequence } from 'remotion';

interface SFX {
  url: string;
  start: number;  // Start time in seconds (cumulative)
  end: number;    // End time in seconds (cumulative)
  volume: number;
  name: string;
  align: string;
  section: number;
}

interface SoundEffectsProps {
  sfxs: SFX[];
//   isDownload?: boolean;
}

const PremountedSFX: React.FC<{
  src: string;
//   startFrom: number;
//   endAt: number;
  volume: number | ((f: number) => number);
  premountFor: number;
  sfxStartTime: number;  // Added to track SFX start time
  sfxEndTime: number;    // Added to track SFX end time
}> = ({ src, volume, premountFor, sfxStartTime, sfxEndTime }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const currentTimeSeconds = frame / fps;
  const isPremounting = frame < 0 && frame >= -premountFor;

  // Calculate volume based on current time in seconds
  const getVolumeAtTime = typeof volume === 'function' 
    ? volume(currentTimeSeconds) 
    : volume;
  // Only play audio if we're within the time window or premounting
  if (!isPremounting && (currentTimeSeconds < sfxStartTime - (premountFor / fps) || currentTimeSeconds > sfxEndTime)) {
    return null;
  }
  if(Math.round((sfxEndTime - sfxStartTime) * fps) > 0){
    return (
    <Sequence from={Math.round(sfxStartTime * fps)} durationInFrames={Math.round((sfxEndTime - sfxStartTime) * fps)}>
      <Audio
        src={src}
        startFrom={0}
        volume={getVolumeAtTime}
      />
    </Sequence>
  )
  }else{
    return null
  }

//   return (
//     <Sequence from={Math.round(sfxStartTime * fps)} durationInFrames={Math.round((sfxEndTime - sfxStartTime) * fps)}>
//       <Audio
//         src={src}
//         startFrom={0}
//         volume={getVolumeAtTime}
//       />
//     </Sequence>
//   );
};

export const SoundEffects: React.FC<SoundEffectsProps> = ({ sfxs}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const currentTimeSeconds = frame / fps;

  // Don't play SFX during download/render if specified
//   if (isDownload) {
//     return null;
//   }
  return (
    <>
      {sfxs.map((sfx, index) => {
        // Use time-based calculations instead of frames
        const fadeDurationSeconds = Math.min(0.3, (sfx.end - sfx.start) / 4); // 0.3 seconds or 1/4 of duration

        // Only render Audio component if we're within or approaching the SFX time window
        if (currentTimeSeconds < sfx.start - 3 || currentTimeSeconds > sfx.end) {
          return null;
        }

        // Create a volume function that handles fading and base volume
        const volumeFunction = (timeSeconds: number) => {
          let volumeMultiplier = sfx.volume;

          if (timeSeconds < sfx.start + fadeDurationSeconds) {
            // Fade in
            volumeMultiplier = interpolate(
              timeSeconds,
              [sfx.start, sfx.start + fadeDurationSeconds],
              [0, 1],
              {
                extrapolateLeft: 'clamp',
                extrapolateRight: 'clamp',
              }
            );
          } else if (timeSeconds > sfx.end - fadeDurationSeconds) {
            // Fade out
            volumeMultiplier = interpolate(
              timeSeconds,
              [sfx.end - fadeDurationSeconds, sfx.end],
              [1, 0],
              {
                extrapolateLeft: 'clamp',
                extrapolateRight: 'clamp',
              }
            );
          }

          return sfx.volume
        };

        // Convert seconds to frames for startFrom and endAt
    //    t  const startFromFrames = 0;  // Start from beginning of the audio
    //     consendAtFrames = Math.round((sfx.end - sfx.start) * fps);  // Convert duration to frames

        return (
          <PremountedSFX
            key={`sfx-${index}-${sfx.start}`}
            src={sfx.url}
            // startFrom={startFromFrames}
            // endAt={endAtFrames}
            volume={volumeFunction}
            premountFor={90}
            sfxStartTime={sfx.start}
            sfxEndTime={sfx.end}
          />
        );
      })}
    </>
  );
}; 